<template>
    <Stepper>
        <DetailsSection :noBorder="!cancellationInfo.consumed" :class="{ 'pb-0': !cancellationInfo.consumed }">
            <TopSection>
                <template v-slot:header>
                    {{ $t('Cancellation.header') }}
                </template>
            </TopSection>

            <CancelableText v-if="cancellationInfo.consumed" :date="cancellationInfo.productData.arrivalDate" />
        </DetailsSection>

        <CancellationScopeSection
            v-if="cancellationInfo.numberOfVoucherCodes > 1"
            :number-of-voucher-codes="cancellationInfo.numberOfVoucherCodes"
            :cancelCompleteOrder.sync="cancellation.cancelCompleteOrder"
        />

        <CancellationReasonSection
            :cancellationReason.sync="cancellation.cancellationReason"
            :cancellationText.sync="cancellation.cancellationText"
        />

        <RefundSection
            :is-value-voucher="false"
            :amountToRefund="cancellationInfo.amountForRefund"
            :originalPaymentStatus="cancellationInfo.originalPaymentStatus"
            :refund-method.sync="cancellation.refundMethod"
            :originalPaymentMethod="cancellationInfo.originalPaymentMethod"
        />

        <DetailsSection class="py-4">
            <input type="hidden" name="action" :value="'cancel'" />

            <div class="text-center">
                <button class="btn btn-primary btn-lg text-uppercase" type="submit">
                    <translate v-if="cancellationInfo.consumed" path="Cancellation.button.sendRequest" />
                    <translate v-else path="Cancellation.button.sendCancellation" />
                </button>
            </div>
        </DetailsSection>
    </Stepper>
</template>

<script>
import TopSection from '@/components/checkout/TopSection';
import CancelableText from '@/components/cancellation/CancelableText';
import Stepper from '@/components/checkout/Stepper';
import DetailsSection from '@/components/DetailsSection';
import ButtonGroup from '@/components/ButtonGroup';
import CancellationReasonSection from '@/components/cancellation/CancellationReasonSection';
import CancellationScopeSection from '@/components/cancellation/CancellationScopeSection';
import RefundSection from '@/components/cancellation/RefundSection';
import CustomerData from '@/components/cancellation/CustomerData';
import BankAccountData from '@/components/cancellation/BankAccountData';

export default {
    name: 'HotelVoucherCancellation',
    components: {
        TopSection,
        CancelableText,
        Stepper,
        DetailsSection,
        ButtonGroup,
        CancellationReasonSection,
        CancellationScopeSection,
        RefundSection,
        CustomerData,
        BankAccountData
    },
    data() {
        const cancelText = this.$t('Generic.cancel');

        return {
            cancelText,
            cancellationMethod: cancelText,
            cancellationMethods: [
                {
                    text: cancelText,
                    value: cancelText
                }
            ]
        };
    },
    computed: {
        isBankDataRequired() {
            console.dir(this.cancellationInfo);
            let paymentMethod = this.cancellationInfo.originalPaymentMethod;
            return (
                this.cancellation.refundMethod !== 'Valuevoucher' &&
                (paymentMethod === 'Paydirekt' ||
                    paymentMethod === 'SofortUeberweisung' ||
                    paymentMethod === 'Prepayment')
            );
        }
    },
    props: {
        cancellationInfo: {
            type: Object,
            required: true
        },
        cancellation: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';

.cancellation-method-buttons {
    ::v-deep .btn {
        padding-left: variables.$grid-gutter-width;
        padding-right: variables.$grid-gutter-width;
    }
}
</style>
